import { api } from "./base";

export const postContactUs = async ({ locale, values }) => {
  api.defaults.headers = { locale };
  const res = await api.post("/message", { ...values });
  return res;
};
